// @flow
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import "./styles/style.scss";
import "./App.scss";
import App from "./preview/App";
import BrowserNotSupported from "./components/BrowserNotSupported/BrowserNotSupported";
import RootNodeProvider from "./helper/RootNodeProvider";
import {createRoot} from "react-dom/client";
import store from "./store";
import {Provider} from "react-redux";
import LangSwitchProvider from "./container/LangSwitchProvider";
import CookiesDisabled from "./components/BrowserNotSupported/CookiesDisabled";

const isInternetExplorer = !!document.documentMode;

const renderCookiesDisabledFallback = () => {
    return <Provider store={store}>
	<LangSwitchProvider>
		<CookiesDisabled/>
	</LangSwitchProvider>
    </Provider>;
};

const checkStorageAllowance = () => {
    let storage;
    try {
        storage = window["localStorage"];
        let x = "__storage_test__";
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    } catch (e) {
        return e instanceof window.DOMException && (e.code === 22 || e.code === 1014 || e.name === "QuotaExceededError" || e.name === "NS_ERROR_DOM_QUOTA_REACHED") && (storage && storage.length !== 0);
    }
};

const render = () => {
    const previewRootNode = createRoot(RootNodeProvider.getPreviewRootNode());
    if (!checkStorageAllowance()) {
        previewRootNode.render(renderCookiesDisabledFallback());
    } else {
        previewRootNode.render(
	<Provider store={store}>
		{isInternetExplorer
                    ? <BrowserNotSupported/>
                    : <App/>
                }
	</Provider>
        );
    }
};

render();
